import React from 'react';
import { Alert } from '@trussworks/react-uswds';

export function USWDSAlert(props) {
  return <Alert {...props} />;
}
